import script from "./SearchResultDetailsPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultDetailsPane.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultDetailsPane.vue?vue&type=style&index=0&id=36a15113&lang=scss"

const __exports__ = script;

export default __exports__